/**
 * Lifecycle rules a task and its board copy share (MYAC-1639) — no Firestore
 * import, so the pure utils that ask them stay pure.
 */
/** The two lifecycle fields the rules below read, on a task or its board copy. */
export interface LifecycleFields {
  lifecycle?: string | null
  archived_from?: string | null
}

/**
 * Archived straight from `parked`: the hidden task of an action a re-assessment
 * dropped (MYAC-1639) — CMS `never_accepted`. It was never accepted, so it owns
 * no row, counts as no acceptance, and leaves the row's own decision route
 * open. Not "archived with a pending decision", which an accepted task sent
 * back and then retired carries too, and whose row must keep reading as taken.
 */
export function taskNeverAccepted(task: LifecycleFields | null | undefined): boolean {
  return task?.lifecycle === 'archived' && task.archived_from === 'parked'
}

/**
 * Never on any board, Inactive column included (MYAC-1639): the hidden task of
 * an action still being decided on, or one retired before it was ever added.
 */
export function taskHiddenFromBoard(task: LifecycleFields | null | undefined): boolean {
  return task?.lifecycle === 'parked' || taskNeverAccepted(task)
}
